<script setup>
import router, { menuRoutes, menuRouteEnum } from '@/router'
import { usePlanningStore } from '@/stores/planning.store'

defineProps({
  groupIds: { type: Array, default: () => [] },
})

const planningStore = usePlanningStore()

const navigateToGroup = (groupId) => {
  const group = planningStore.getGroupById(groupId)
  if (group) {
    router.push({ path: menuRoutes[menuRouteEnum.GROUPS], query: { code: group.code } })
  }
}
</script>
<template>
  <div v-if="groupIds?.length" class="group-links">
    <a
      v-for="groupId in groupIds"
      :key="groupId"
      href="#"
      class="group-link"
      @click.stop.prevent="navigateToGroup(groupId)"
    >
      <i class="mdi mdi-select-group" />
      {{ planningStore.getGroupById(groupId)?.name }}
    </a>
  </div>
</template>
<style scoped>
.group-links {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.group-link {
  display: flex;
  align-items: center;
  gap: 4px;
  text-decoration: none;
  color: var(--q-primary);
}
.group-link:hover {
  text-decoration: underline;
}
.group-link i {
  font-size: 1rem;
  flex-shrink: 0;
}
</style>
